var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"motif",attrs:{"data-height":_vm.m.motifHeight,"data-width":_vm.m.motifWidth,"data-wide":_vm.m.motifWidth>54 ? 1 : 0}},[_c('img',{attrs:{"src":_vm.imgsrc,"alt":_vm.m.motifName,"title":_vm.m.motifName}})])}
var staticRenderFns = []

export { render, staticRenderFns }